import {AppShell, Divider} from "@mantine/core";
import SearchTextInput from "./search-text-input/SearchTextInput";
import FoldersView from "./folders/FoldersView";
import kubalaLogo from "./Kubala.png";

type NavbarProps = {}

/**
 * Default Navbar to be use in Layout.tsx
 *
 * Not implemented yet.
 * @param _props
 * @constructor
 * @author Kacper Faber
 * @since 0.1.4
 */
function Navbar(_props: NavbarProps) {
  return (
    <AppShell.Navbar p="sm" bg="#616568" withBorder={false}>
      <img
        src={kubalaLogo}
        alt="Kubala Logo"
        style={{marginBottom: 25, marginTop: 25, paddingLeft: 10, paddingRight: 10, filter: "brightness(0) invert(1)"}}
      />

      <SearchTextInput/>

      <Divider
        my="xl"
        color="#a4a6a8"
      />

      <FoldersView/>
    </AppShell.Navbar>
  );
}

export default Navbar;

// TODO: Navbar.tsx
//  Use colours from theme.